// Formatters
export const formatCurrency = (value) => 
  new Intl.NumberFormat('fr-FR', { 
    style: 'currency', 
    currency: 'EUR', 
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  }).format(value || 0);

export const formatCurrencyFull = (value) => 
  new Intl.NumberFormat('fr-FR', { 
    style: 'currency', 
    currency: 'EUR', 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }).format(value || 0);

export const formatPercent = (value) => 
  new Intl.NumberFormat('fr-FR', { 
    style: 'percent', 
    minimumFractionDigits: 1, 
    maximumFractionDigits: 1 
  }).format(value || 0);
